import React, {PureComponent} from 'react';
import {Link} from "react-router-dom";
import {getCurrentUserId, getJwt} from '../../../services/authService';
import http from '../../../services/httpService';
import InputRegular from '../../common/InputRegular';
import Header from '../Header'
import ReactGA from "react-ga";

class CreateTeam extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            user: {},
            teamId: '',
            data:
                {
                    team: ''
                },
            spinnerActive: false,
            errors: {},
            fieldsCheckActive: false,
            errorsList: []
        };
    }

    componentDidMount() {
       // ReactGA.pageview(window.location.pathname + window.location.search);

    }

    doSubmit = async () => {
        await this.setState({fieldsCheckActive: true, spinnerActive: true})
        let anyErrorActive = false;
        this.state.errorsList.map(error=>error ? anyErrorActive = true : '')
        setTimeout(async ()=> {
            if(!anyErrorActive){
                if(localStorage.navigateBackTo){
                    try {
                        this.setState({
                            spinnerActive: true,
                            unsuccessfulPostCall: false
                        });
                        const newTeamResult = await http.post('/api/user/' + getCurrentUserId() + '/team', { team_name: this.state.data.team }, { headers: { authorization: getJwt() } })
                        await this.setState({
                            teamId: newTeamResult.data.data.id
                        });
                        localStorage.setItem("selectedTeam", JSON.stringify(newTeamResult.data.data.id));
                        this.setState({ spinnerActive: false });
                        this.props.history.push('/team-members')
                    } catch(ex) {
                        this.setState({
                            spinnerActive: false,
                            unsuccessfulPostCall: true
                        });
                        if(ex.response && (ex.response.status === 400 || ex.response.status === 422)){
                            const errors_obj = this.state.errors;
                            let errors = { ...errors_obj };
                            errors = ex.response.data.errors;
                            this.setState({ errors });
                        }
                        if(ex.response && ex.response.status === 401){
                            const errors_obj = this.state.errors;
                            let errors = { ...errors_obj };
                            errors.email = ex.response.data.message;
                            this.setState({ errors });
                        }
                    }
                } else {
                    //creating a feed with name sent from Feed Name
                    try {
                        this.setState({
                            spinnerActive: true,
                            unsuccessfulPostCall: false
                        });
                        const newFeedResult = await http.post('/api/user/' + getCurrentUserId() + '/source', { name: localStorage.getItem("name") }, { headers: { authorization: getJwt() } });

                        localStorage.setItem("feed_id", JSON.stringify(newFeedResult.data.id));

                        // console.log('new feed: ', newFeedResult);

                        //creating new team

                        try {
                            this.setState({
                                spinnerActive: true,
                                unsuccessfulPostCall: false
                            });
                            const newTeamResult = await http.post('/api/user/' + getCurrentUserId() + '/team', { team_name: this.state.data.team }, { headers: { authorization: getJwt() } });
                            await this.setState({
                                teamId: newTeamResult.data.data.id
                            });
                            //assigning feed to created team
                            try {
                                const feedToTeam = await http.post('/api/user/' + getCurrentUserId() + '/team/feed/' + newFeedResult.data.id, { team_id: this.state.teamId }, { headers: { authorization: getJwt() } })
                                // console.log('feed to team response: ', feedToTeam);
                                this.props.history.push('/feed-source');
                                // console.log('feed id: ', newFeedResult.data.id);
                            } catch(ex) {
                                this.setState({
                                    spinnerActive: false,
                                    unsuccessfulPostCall: true
                                });
                                if(ex.response && (ex.response.status === 400 || ex.response.status === 422)){
                                    const errors_obj = this.state.errors;
                                    let errors = { ...errors_obj };
                                    errors = ex.response.data.errors;
                                    this.setState({ errors });
                                }
                                if(ex.response && ex.response.status === 401){
                                    const errors_obj = this.state.errors;
                                    let errors = { ...errors_obj };
                                    errors.email = ex.response.data.message;
                                    this.setState({ errors });
                                }
                            }
                        } catch(ex) {
                            this.setState({
                                spinnerActive: false,
                                unsuccessfulPostCall: true
                            });
                            if(ex.response && (ex.response.status === 400 || ex.response.status === 422)){
                                const errors_obj = this.state.errors;
                                let errors = { ...errors_obj };
                                errors = ex.response.data.errors;
                                this.setState({ errors });
                            }
                            if(ex.response && ex.response.status === 401){
                                const errors_obj = this.state.errors;
                                let errors = { ...errors_obj };
                                errors.email = ex.response.data.message;
                                this.setState({ errors });
                            }
                        }

                    } catch(ex) {
                        this.setState({
                            spinnerActive: false,
                            unsuccessfulPostCall: true
                        });
                        if(ex.response && (ex.response.status === 400 || ex.response.status === 422)){
                            const errors_obj = this.state.errors;
                            let errors = { ...errors_obj };
                            errors = ex.response.data.errors;
                            this.setState({ errors });
                        }
                        if(ex.response && ex.response.status === 401){
                            const errors_obj = this.state.errors;
                            let errors = { ...errors_obj };
                            errors.email = ex.response.data.message;
                            this.setState({ errors });
                        }
                    }
                }
            }else{
                this.setState({spinnerActive: false})
            }
        },500);
    };

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
    }


    render() {


        return (
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content">
                    <div className="onboarding-panel">
                        <h1 className='onboarding-title distribution-title'><span>Choose a name for your</span> <br/>
                            <span>new team</span></h1>
                        <p className='m-m-b'>In Emitto, every user is a part of a team.<br/>You can be in a team by
                            yourself, or you can
                            add more<br/> team members later.</p>


                            {/*{this.renderInput('team', 'text', 'Ex. Team Name')}*/}
                            {/*{!this.state.spinnerActive ?*/}
                            {/*    this.renderButton("Next")*/}
                            {/*    :*/}
                            {/*    this.renderButtonSpinner("Next")*/}
                            {/*}*/}
                        <InputRegular
                            id="1"
                            label1=""
                            label2=""
                            placeholder="Ex. Team Name"
                            type='text'
                            onChange={ (value)=>this.setState({ data:{
                                    team: value
                                }})}
                            value={this.state.data.team}
                            required={true}
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            updateErrorsList={this.updateErrorsList}
                            errorMessage="Team Name can't be empty"
                        />
                        <div className='margin-bottom-20'/>
                        {this.state.spinnerActive ?
                            <button className='btn-action btn-spinner margin-bottom-30 margin-top-10' disabled={true}>Next  <i className='fa fa-spin fa-spinner'></i></button>
                            :
                            <button className='btn-action margin-bottom-30 margin-top-10' onClick={this.doSubmit}>Next</button>
                        }
                        {
                            localStorage.navigateBackTo ?
                                <div className='panel-message text-center'>
                                    <p><Link onClick={() => {
                                        this.props.history.push(localStorage.navigateBackTo)
                                        localStorage.removeItem('navigateBackTo')
                                    }} to='#'>Cancel</Link></p>
                                </div> :
                                <div className='panel-message'>

                                    <p>By continuing you agree to our <a href="https://app.emitto.io/privacy">Customer
                                        Terms
                                        of Service</a>, </p>
                                    <p><a href="https://app.emitto.io/privacy">Privacy Policy</a>, and <a
                                        href="https://app.emitto.io/privacy">Cookie Policy.</a></p>
                                </div>
                        }

                    </div>
                </div>

            </div>
        )
    }
}

export default CreateTeam;